// 出撃キャラ（＝TOPに立つキャラ）。ソシャゲのホームと同じく「ホームで選んだキャラ＝出撃するキャラ」を1つの設定で持つ。
// TOP と出撃画面のどちらで変えても同じ値（Profile.oshi）が変わる。
import { api } from '../api';
import type { CharId } from '@hyakki/core';
import { patch, state } from '../state';
import { toast } from './overlay';
import { errorText } from './status';

export async function setLeader(id: CharId) {
  if (id === state.oshi) return;
  const prev = state.oshi;
  patch({ oshi: id });
  try {
    await api.setOshi(id);
  } catch (err) {
    if (!(err as { notReady?: boolean }).notReady) {
      patch({ oshi: prev });
      toast(errorText(err), 'error');
    }
  }
}
